import React, { useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { BsFilter } from "react-icons/bs";
import { BiX } from "react-icons/bi";

const ClearFilters = ({
	count,
	changeFromDate,
	changeToDate,
	changeOrderStatus,
}) => {
	const ref = useRef();

	const clearFilters = () => {
		changeFromDate("");
		changeToDate("");
		changeOrderStatus("");
		ref.current.hide();
	};

	return (
		<>
			<button
				type="button"
				className="relative"
				onClick={(e) => ref.current.toggle(e)}
			>
				<BsFilter size={40} />
				<span className="absolute top-1 right-1 h-5 w-5 border border-akgreen rounded-full bg-white">
					{count || 0}
				</span>
			</button>
			<OverlayPanel ref={ref}>
				<button
					type="button"
					className="w-full flex items-center justify-center py-2 text-white bg-akgreen rounded"
					onClick={clearFilters}
				>
					<span className="ml-2">Clear filters</span>
					<BiX size={30} />
				</button>
			</OverlayPanel>
		</>
	);
};

export default ClearFilters;
